module.exports = {
  author: 'Everlywell', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.everlywell.com/', // URL used for author and publisher schema, can be a social profile or other personal site
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  copyright: 'Copyright © 2020 EverlyWell, Inc.', // Copyright string for the RSS feed
  keywords:
    'home health testing, online blood test, online health test, at home blood test, at home lab test, blood test, urine test, saliva test, food intolerance test, food sensitivity test, fertility test, hormone testing, self testing',
  postsPerHomePage: 10, // Number of posts shown on the 1st page of the index.js template (home page)
  postsPerPage: 10, // Number of posts shown on paginated pages
  publisher: 'Everlywell', // Organization name used for SEO schema
  shortTitle: 'Everlywell', // Used for App manifest e.g. Mobile Home Screen
  siteDescription:
    'Home health testing has never been easier. Order at-home tests directly to your door and get your results online within days.',
  siteLogo: '/logo/ew-mark-1024.png', // Logo used for SEO, RSS, and App manifest
  title: 'Everlywell - Innovative at-home Health Testing',
  siteTitle:
    'Home Health Testing | Results You Can Understand | Everlywell',
  siteTitleAlt: 'Everlywell: Home Health Testing Made Easy', // This allows an alternative site title for SEO schema.
  siteUrl: 'https://www.everlywell.com', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  themeColor: '#121212', // Used for Offline Manifest
  userTwitter: '@everly_well', // Change for Twitter Cards
};
